<ChartExportStructure
  title="Only one third of non-plastic substitute exports are value-added products"
  subtitle="Structure of global exports value of non-plastic substitutes, billions of dollars, 2024"
  source="UN Trade and Development (UNCTAD) based on UNCTADstat."
  note="Raw materials and value-added products are each broken down into their main product groups. Hover over or tap a tile to see the exact export value."
/>
